import { ZapMetadataStep } from "@zapier/canvas-state";
import isFilterStep from "./isFilterStep";

type Params = {
  stepNumber: number;
  step: ZapMetadataStep;
  isPath: boolean;
  serviceName: string;
};

const getZapStepTitle = ({
  stepNumber,
  step,
  isPath,
  serviceName,
}: Params): string => {
  const title = step.title;

  if (title) {
    return title;
  }

  const isFirstStep = stepNumber === 1;
  if (isFirstStep) {
    return "Trigger";
  }

  if (isPath) {
    return "Paths";
  }

  if (isFilterStep(step)) {
    return "Only continue if...";
  }

  if (serviceName) {
    return serviceName;
  }

  return "Action";
};

export default getZapStepTitle;
